module.exports = __webpack_public_path__ + "img/capa1.5d04888a.webp";